export default "__VITE_ASSET__7960d113__"